import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { HomeComponent } from './home/home/home.component';
import { ApiWelcomeComponent } from './core/api-docs/api-welcome/api-welcome.component';
import { ObjectFormComponent } from './core/components/pages/object-form/object-form.component';
import { ModuleListComponent } from './core/components/pages/module-list/module-list.component';
import { SystemComponent } from './core/components/pages/system/system.component';
import { SystemStatusComponent } from './core/components/pages/system-status/system-status.component';
import { ModelStatusComponent } from './core/components/pages/model-status/model-status.component';
import { CreateComponent } from './core/components/tenants/create/create.component';
import { DashboardComponent } from './core/components/pages/dashboard/dashboard.component';
import { ImportFileComponent } from './core/components/tenants/importFile/import-file';
import { SignupComponent } from './core/components/signup/signup.component';
import { ObjectAccessComponent } from './core/components/pages/object-access/object-access.component';
import { adminGuard } from './core/guards/admin.guard';
import { notViewerGuard } from './core/guards/not-viewer.guard';

const routes: Routes = [
  { path: 'signup/:tenantCode/:subject/:token', component: SignupComponent },
  { path: 'new', component: CreateComponent, canActivate: [AuthGuard]} ,

  { path: 'data/:tenantCode/:type/new', component: ObjectFormComponent, canActivate: [AuthGuard, notViewerGuard]} ,
  { path: 'data/:tenantCode/:referenceClass/:referenceId/:type/new', component: ObjectFormComponent, canActivate: [AuthGuard, notViewerGuard]} ,
  { path: 'data/:tenantCode/:type/:id/edit', component: ObjectFormComponent, canActivate: [AuthGuard, notViewerGuard]} ,
  { path: 'data/:tenantCode/:type/:id/access', component: ObjectAccessComponent, canActivate: [AuthGuard, adminGuard]} ,

  { path: 'apidocs/:tenantCode', component: ApiWelcomeComponent, canActivate: [AuthGuard]} ,

  { path: ':tenantCode/modules', component: ModuleListComponent, canActivate: [AuthGuard]} ,
  { path: ':tenantCode/system', component: SystemComponent, canActivate: [AuthGuard, adminGuard]} ,
  { path: ':tenantCode/system/status', component: SystemStatusComponent, canActivate: [AuthGuard, adminGuard]} ,
  { path: ':tenantCode/system/model', component: ModelStatusComponent, canActivate: [AuthGuard, adminGuard]} ,
  { path: ':tenantCode/import', component: ImportFileComponent, canActivate: [AuthGuard]} ,

  { path: 'system/:tenantCode/:type/new', component: ObjectFormComponent, data: { system: true }, canActivate: [AuthGuard, adminGuard]} ,
  { path: 'system/:tenantCode/:referenceClass/:referenceId/:type/new', component: ObjectFormComponent, data: { system: true }, canActivate: [AuthGuard, adminGuard]} ,
  { path: 'system/:tenantCode/:type/:id/edit', component: ObjectFormComponent, data: { system: true }, canActivate: [AuthGuard, adminGuard]} ,
  { path: 'system/:tenantCode/:type/:id', component: DashboardComponent, data: { system: true }, canActivate: [AuthGuard, adminGuard]} ,
  { path: 'system/:tenantCode/:type', component: DashboardComponent, data: { system: true }, canActivate: [AuthGuard, adminGuard]} ,

  { path: ':tenantCode', component: DashboardComponent, canActivate: [AuthGuard]} ,
  { path: ':tenantCode/:type', component: DashboardComponent, canActivate: [AuthGuard]} ,
  { path: 'data/:tenantCode/:type/:id', component: DashboardComponent, canActivate: [AuthGuard]} ,

  { path: '', component: HomeComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
